import AccountType from '@/models/Shared/AccountType';

export default class CreatePaymentOrderRequest {
    accountId: string;
    accountType: AccountType;
    name: string = '';
    reference: string = '';
    payeeType: string;
    sortCode: string = '';
    accountNumber: string = '';
    iban: string = '';
    addressLine1: string;
    addressLine2: string;
    city: string;
    county: string;
    postCode: string;
    country: string = '';
}